import * as aTypes from "../actions/actionTypes";
import { updateObject } from "../../helpers/index";

const initialState = {
  contents: null,
  filteredContents: null,
  filters: {
    tags: [],
  },
  error_contents: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.CONTS_SET:
      return setContents(state, action);
    case aTypes.CONTS_FILTRED_SET:
      return setFiltredContents(state, action);
    case aTypes.CONTS_FAIL:
      return fetchContentsFailed(state, action);
    default:
      return state;
  }
};

const setContents = (state, action) => {
  return updateObject(state, { contents: action.contents });
};

const setFiltredContents = (state, action) => {
  return updateObject(state, {
    filteredContents: action.filteredContents,
  });
};

const fetchContentsFailed = (state, action) => {
  return updateObject(state, { error_contents: action.error });
};

export default reducer;
